import React from "react";
import { Link } from "react-router-dom";
import ExerciseHistory from "../../_clients/ExerciseHistory";
import "./Header.scss";

export default function DropDown({set_exercise_history_tab,exerciseHistoryTab, title, subtitle = false }) {
  
  return (
    <div className="c-header c-header-update">
      <div className="c-header-container">
        <div className="c-header-nav">
          <h1 className="c-header-title">{title}</h1>
          {subtitle &&
            <button className="c-header-back" onClick={() => {window.history.back();}}>back</button>
          }

         
        </div>
      </div>
    </div>
  );
}
